import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Users, Award, TrendingUp, Plus, CheckCircle, Clock, FileText, ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
export function EventCoordinatorDashboard() {
  const navigate = useNavigate();
  const stats = [{
    label: 'Acara Aktif',
    value: '12',
    trend: '3 minggu ini',
    icon: Calendar,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Total Pendaftaran',
    value: '456',
    trend: '+23% bulan ini',
    icon: Users,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Sertifikat Diterbitkan',
    value: '234',
    trend: 'Kuartal ini',
    icon: Award,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Tingkat Kehadiran',
    value: '87%',
    trend: '+5% dari bulan lalu',
    icon: TrendingUp,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }];
  const upcomingEvents = [{
    id: 1,
    title: 'Workshop React',
    date: '15 Jan 2025',
    time: '09:00 - 17:00',
    registered: 28,
    capacity: 30,
    status: 'confirmed'
  }, {
    id: 2,
    title: 'Seminar AI & ML',
    date: '20 Jan 2025',
    time: '14:00 - 17:00',
    registered: 67,
    capacity: 100,
    status: 'confirmed'
  }, {
    id: 3,
    title: 'Meetup Bulanan',
    date: '22 Jan 2025',
    time: '19:00 - 21:00',
    registered: 23,
    capacity: 50,
    status: 'pending'
  }];
  const recentRegistrations = [{
    id: 1,
    name: 'Ahmad Rizki',
    event: 'Workshop React',
    date: '2 jam lalu',
    status: 'confirmed'
  }, {
    id: 2,
    name: 'Siti Rahayu',
    event: 'Seminar AI & ML',
    date: '5 jam lalu',
    status: 'confirmed'
  }, {
    id: 3,
    name: 'Budi Hartono',
    event: 'Workshop React',
    date: '1 hari lalu',
    status: 'pending'
  }];
  return <div className="min-h-screen bg-white" data-id="element-2700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-2701">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-2702">
          <div data-id="element-2703">
            <div className="flex items-center gap-2 sm:gap-3 mb-2" data-id="element-2704">
              <h1 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-neutral-900" data-id="element-2705">
                Dasbor Koordinator Acara
              </h1>
              <Badge className="bg-success text-white font-semibold text-xs" data-id="element-2706">
                KOORDINATOR
              </Badge>
            </div>
            <p className="text-sm sm:text-base text-neutral-600" data-id="element-2707">
              Kelola acara, pendaftaran, dan sertifikat
            </p>
          </div>
          <div className="flex gap-2 sm:gap-3" data-id="element-2708">
            <Button variant="secondary" size="sm" onClick={() => navigate('/events/certificates')} className="flex-1 sm:flex-none" data-id="element-2709">
              <Award className="w-4 h-4 sm:mr-2" data-id="element-2710" />
              <span className="hidden sm:inline" data-id="element-2711">Sertifikat</span>
              <span className="sm:hidden" data-id="element-2712">Cert</span>
            </Button>
            <Button size="sm" onClick={() => navigate('/events/create')} className="flex-1 sm:flex-none" data-id="element-2713">
              <Plus className="w-4 h-4 sm:mr-2" data-id="element-2714" />
              <span className="hidden sm:inline" data-id="element-2715">Buat Acara</span>
              <span className="sm:hidden" data-id="element-2716">Buat</span>
            </Button>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-2717">
          {stats.map((stat, i) => <Card key={i} data-id="element-2718">
              <CardContent className="p-4 sm:p-6" data-id="element-2719">
                <div className="flex justify-between items-start mb-3 sm:mb-4" data-id="element-2720">
                  <div className={`p-2 sm:p-3 rounded-lg ${stat.bgColor}`} data-id="element-2721">
                    <stat.icon className={`w-5 h-5 sm:w-6 sm:h-6 ${stat.color}`} data-id="element-2722" />
                  </div>
                  <TrendingUp className="w-4 h-4 text-success" data-id="element-2723" />
                </div>
                <div className="space-y-1" data-id="element-2724">
                  <h3 className="text-xl sm:text-2xl font-semibold text-neutral-900" data-id="element-2725">
                    {stat.value}
                  </h3>
                  <p className="text-xs sm:text-sm text-neutral-600" data-id="element-2726">
                    {stat.label}
                  </p>
                </div>
                <p className="text-xs mt-2 sm:mt-3 text-neutral-500" data-id="element-2727">
                  {stat.trend}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8" data-id="element-2728">
          {/* Upcoming Events */}
          <Card data-id="element-2729">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-2730">
              <CardTitle className="text-base sm:text-lg" data-id="element-2731">
                Acara Mendatang
              </CardTitle>
              <Button variant="link" className="text-atios-primary text-sm" onClick={() => navigate('/events')} data-id="element-2732">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-2733">
              <div className="space-y-3 sm:space-y-4" data-id="element-2734">
                {upcomingEvents.map(event => <div key={event.id} className="p-3 sm:p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-all cursor-pointer" onClick={() => navigate(`/events/${event.id}`)} data-id="element-2735">
                    <div className="flex items-start justify-between gap-2 mb-2" data-id="element-2736">
                      <h4 className="font-medium text-sm sm:text-base text-neutral-900 flex-1" data-id="element-2737">
                        {event.title}
                      </h4>
                      <Badge variant={event.status === 'confirmed' ? 'success' : 'warning'} className="text-xs flex-shrink-0" data-id="element-2738">
                        {event.status === 'confirmed' ? 'DIKONFIRMASI' : 'MENUNGGU'}
                      </Badge>
                    </div>
                    <p className="text-xs sm:text-sm text-neutral-600 mb-2" data-id="element-2739">
                      {event.date} • {event.time}
                    </p>
                    <div className="flex items-center justify-between" data-id="element-2740">
                      <span className="text-xs sm:text-sm text-neutral-600" data-id="element-2741">
                        {event.registered}/{event.capacity} terdaftar
                      </span>
                      <div className="h-2 w-20 sm:w-24 bg-neutral-100 rounded-full overflow-hidden" data-id="element-2742">
                        <div className="h-full bg-atios-primary rounded-full" style={{
                      width: `${event.registered / event.capacity * 100}%`
                    }} data-id="element-2743" />
                      </div>
                    </div>
                  </div>)}
              </div>
            </CardContent>
          </Card>

          {/* Recent Registrations */}
          <Card data-id="element-2744">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-2745">
              <CardTitle className="text-base sm:text-lg" data-id="element-2746">
                Pendaftaran Terbaru
              </CardTitle>
              <Button variant="link" className="text-atios-primary text-sm" onClick={() => navigate('/events/registrations')} data-id="element-2747">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-2748">
              <div className="overflow-x-auto -mx-4 sm:mx-0" data-id="element-2749">
                <div className="inline-block min-w-full align-middle" data-id="element-2750">
                  <Table data-id="element-2751">
                    <TableHeader data-id="element-2752">
                      <TableRow data-id="element-2753">
                        <TableHead className="text-xs sm:text-sm" data-id="element-2754">
                          Nama
                        </TableHead>
                        <TableHead className="text-xs sm:text-sm" data-id="element-2755">
                          Acara
                        </TableHead>
                        <TableHead className="text-xs sm:text-sm" data-id="element-2756">
                          Status
                        </TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody data-id="element-2757">
                      {recentRegistrations.map(reg => <TableRow key={reg.id} data-id="element-2758">
                          <TableCell data-id="element-2759">
                            <div data-id="element-2760">
                              <p className="font-medium text-xs sm:text-sm text-neutral-900" data-id="element-2761">
                                {reg.name}
                              </p>
                              <p className="text-xs text-neutral-500" data-id="element-2762">
                                {reg.date}
                              </p>
                            </div>
                          </TableCell>
                          <TableCell className="text-neutral-600 text-xs sm:text-sm" data-id="element-2763">
                            {reg.event}
                          </TableCell>
                          <TableCell data-id="element-2764">
                            <Badge variant={reg.status === 'confirmed' ? 'success' : 'warning'} className="text-xs" data-id="element-2765">
                              {reg.status === 'confirmed' ? 'DIKONFIRMASI' : 'MENUNGGU'}
                            </Badge>
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Quick Actions */}
        <div data-id="element-2766">
          <h2 className="text-base sm:text-lg font-semibold text-neutral-900 mb-4" data-id="element-2767">
            Aksi Cepat
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4" data-id="element-2768">
            {[{
            label: 'Buat Acara',
            icon: Plus,
            onClick: () => navigate('/events/create')
          }, {
            label: 'Kelola Pendaftaran',
            icon: Users,
            onClick: () => navigate('/events/registrations')
          }, {
            label: 'Terbitkan Sertifikat',
            icon: Award,
            onClick: () => navigate('/events/certificates')
          }, {
            label: 'Laporan Acara',
            icon: FileText,
            onClick: () => navigate('/events/reports')
          }].map((action, i) => <Button key={i} variant="secondary" className="h-auto py-3 sm:py-4 flex flex-col gap-2 hover:border-atios-primary transition-all" onClick={action.onClick} data-id="element-2769">
                <action.icon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-2770" />
                <span className="text-xs sm:text-sm text-center" data-id="element-2771">
                  {action.label}
                </span>
              </Button>)}
          </div>
        </div>
      </div>
    </div>;
}